import * as Axios from 'axios';
import store from '@/store'

export default class BaseService {
    protected async makeAxiosCall(config: Axios.AxiosRequestConfig): Promise<Axios.AxiosResponse> {
        try {
            return await Axios.default(config)
        } catch (err:any) {
            if (err.response) {
                if (err.response.status === 401) {
                    store.state.$auth.logout();
                }
            }
            throw err;
        }
    }
}
